<div *ngIf="showInstallBanner" class="pwa-overlay">
  <div class="pwa-install-banner">
    <img [src]="_themeService.blackIconUrl$ | async" alt="App Icon" />
    <a (click)="installApp()" class="pwa-banner-text"> Add to Home Screen </a>
    <button class="close-btn" (click)="dismissBanner()">✕</button>
  </div>
</div>
<router-outlet></router-outlet>
<ng-http-loader [filteredHeaders]="['Skip-Loader']"></ng-http-loader>
